/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ExamStartButton, PrintExamLink } from 'edrolo/domains/exams';
import style from './ExamEntryModal.scss';
import { ORIGIN } from 'edrolo/constants/Analytics';

const ExamStartTranscribeModalBody = ({ examId, onStartOffline, onClose }) => {
  return (
    <div className="modal-body">
      <p className="modal-question">Great work!</p>
      <p className="status">
        Let’s enter the answers from your print-out, so you can view your
        results, and a video solution for each question!
      </p>
      <ExamStartButton examId={examId} onExamStart={onStartOffline}>
        Get my results &raquo;
      </ExamStartButton>
      <a className="no" onClick={onClose}>
        Actually, get me outta here
      </a>
    </div>
  );
};

const ContinueTranscribeModalBody = ({
  examId,
  onStart,
  onStartOffline,
  onClose,
}) => {
  return (
    <div className="modal-body" id="exam-continue-transcribe">
      <p className="modal-question">
        You’ve already started entering your answers from a print-out.
      </p>
      <ul className="modal-options">
        <li>
          <p>I want to finish inputting my answers.</p>
          <a className="button primary" onClick={onStartOffline}>
            Get my results &raquo;
          </a>
        </li>
        <li>
          <p>I want to view the online version.</p>
          <a className="button secondary" onClick={onStart}>
            View the full online version &raquo;
          </a>
        </li>
        <li>
          <p>I want print this out and start again.</p>
          <PrintExamLink
            className="button secondary"
            examId={examId}
            origin={ORIGIN.COURSE_PAGE}
          >
            Print now &raquo;
          </PrintExamLink>
        </li>
      </ul>
      <a className="no" onClick={onClose}>
        Actually, get me outta here
      </a>
    </div>
  );
};

const ExamStartModalBody = ({ examId, onStart, onStartOffline, onClose }) => {
  return (
    <div className="modal-body" id="exam-start">
      <p className="modal-question">Are you ready?</p>
      <ul className="modal-options">
        <li>
          <p>Yes, I want to sit the online version</p>
          <ExamStartButton
            examId={examId}
            onExamStart={onStart}
            className="primary"
          >
            Start now &raquo;
          </ExamStartButton>
        </li>
        <li>
          <p>Yes, but I want to complete a printed version</p>
          <PrintExamLink
            className="button secondary"
            examId={examId}
            origin={ORIGIN.COURSE_PAGE}
          >
            Print now &raquo;
          </PrintExamLink>
        </li>
        <li>
          <p>No, I’ve already completed a printed version.</p>
          <ExamStartButton
            examId={examId}
            onExamStart={onStartOffline}
            className="secondary"
          >
            Get my results &raquo;
          </ExamStartButton>
        </li>
      </ul>
      <a className="no" onClick={onClose}>
        Actually, get me outta here
      </a>
    </div>
  );
};

const ExamContinueModalBody = ({
  examId,
  onStart,
  onStartOffline,
  onClose,
}) => {
  return (
    <div className="modal-body" id="exam-continue">
      <p className="modal-question">
        You’ve already started. <br />
        Would you like to continue?
      </p>
      <ul className="modal-options">
        <li>
          <p>Yes, I want to continue to complete the online version.</p>
          <a className="button primary" onClick={onStart}>
            Continue &raquo;
          </a>
        </li>
        <li>
          <p>No, I want to complete a printed version.</p>
          <PrintExamLink
            className="button secondary"
            examId={examId}
            origin={ORIGIN.COURSE_PAGE}
          />
        </li>
        <li>
          <p>No, I’ve already completed a printed version.</p>
          <a className="button secondary" onClick={onStartOffline}>
            Get my results &raquo;
          </a>
        </li>
      </ul>
      <a className="no" onClick={onClose}>
        Actually, get me outta here
      </a>
    </div>
  );
};

class ExamEntryModal extends Component {
  render() {
    const {
      examId,
      examTitle,
      hasSitting,
      offlineMode,
      onClose,
      handleExamStart,
      handleExamStartOffline,
    } = this.props;

    let className;
    let ModalBody;

    if (offlineMode) {
      // Came from a short link or has a cookie saying they sat offline last
      if (hasSitting) {
        ModalBody = ContinueTranscribeModalBody;
        className = 'continue-transcribe-modal triple-option';
      } else {
        ModalBody = ExamStartTranscribeModalBody;
        className = 'start-transcribe-modal';
      }
    } else if (hasSitting) {
      // Returning to existing exam
      ModalBody = ExamContinueModalBody;
      className = 'continue-exam-modal triple-option';
    } else {
      // First time sitting online
      ModalBody = ExamStartModalBody;
      className = 'start-exam-modal triple-option';
    }

    return (
      <div className={style.examEntryContainer}>
        <Modal
          show
          onHide={onClose}
          title={examTitle}
          id="exam-warning"
          className={className}
        >
          <Modal.Header>
            <Modal.Title>{examTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ModalBody
              examId={examId}
              onStart={handleExamStart}
              onStartOffline={handleExamStartOffline}
              onClose={onClose}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

ExamEntryModal.propTypes = {
  examId: PropTypes.number.isRequired,
  examTitle: PropTypes.string.isRequired,
  hasSitting: PropTypes.bool,
  offlineMode: PropTypes.bool,
  handleExamStart: PropTypes.func.isRequired,
  handleExamStartOffline: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ExamEntryModal;
